{% block sw_customer_detail_content_tab_order %}
    {% parent() %}

    <sw-tabs-item
        :route="{ name: 'vio.customer.price.customer', params: { id: $route.params.id } }"
        :title="$tc('vio-customer-price.general.mainMenuItemGeneral')"
    >
        {{ $tc('vio-customer-price.general.mainMenuItemGeneral') }}
    </sw-tabs-item>
{% endblock %}